class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

close() {
  /*
   * Start closing the drawer.
   */
  this.classList.remove('active');

  /*
   * Unlock page scrolling immediately.
   */
  document.body.classList.remove(
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  );

  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';

  /*
   * Wait for the drawer transition before restoring focus.
   * Restoring focus too early can interfere with Dawn's
   * mobile sticky-header state.
   */
  setTimeout(() => {
    this.classList.remove('animate');

    if (this.activeElement) {
      removeTrapFocus(this.activeElement);
    } else {
      removeTrapFocus();
    }

    const headerSection = document.querySelector('.section-header');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (headerSection) {
      /*
       * Dawn can leave this class behind after the cart closes,
       * which moves the entire header above the screen.
       */
      headerSection.classList.remove(
        'shopify-section-header-hidden'
      );

      headerSection.style.top = '';
    }

    if (headerWrapper) {
      /*
       * Restore the proper transparent homepage state at the top,
       * or the solid sticky state farther down the page.
       */
      headerWrapper.classList.toggle(
        'ds-header-scrolled',
        window.scrollY > 20
      );
    }

    /*
     * Let all existing sticky-header scripts recalculate.
     */
    window.dispatchEvent(new Event('scroll'));
  }, 50);
}

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
  const overlay = this.querySelector('#CartDrawer-Overlay');

  if (overlay) {
    overlay.addEventListener('click', this.close.bind(this));
  }

  this.open();

  /*
   * Reinitialize "Others Also Bought" after the product-page
   * Add to Cart refreshes the cart drawer.
   */
  requestAnimationFrame(() => {
    this.querySelectorAll('product-recommendations').forEach((recommendations) => {
      if (
        typeof recommendations.initializeRecommendations === 'function' &&
        recommendations.dataset.productId
      ) {
        recommendations.initializeRecommendations(
          recommendations.dataset.productId
        );
      }
    });
  });
});
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

window.addEventListener('resize', () => {
  const cart = document.querySelector('cart-drawer');

  if (!cart || !cart.classList.contains('active')) return;

  document.body.classList.add('overflow-hidden');
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
});
